<template>
</template>

<script>

    import request from '@/utils/request'
    export default {
        name: "微信授权",
        data(){
            return{
                code:null,
                state:null

            }
        },
        created:function(){
            var _this = this
            var isReceiveCoupon = this.$route.params.isReceiveCoupon;
            var url = window.location.href
            var redirect_uri = encodeURIComponent(url)
            if(url.indexOf("code") != -1){
                let arr;
                console.log(url)
                arr = url.split("?");
                arr = arr[1].split("#");
                var data=arr[0].split("&");
                var code=data[0].split("=");
                code=code[1];
                console.log(data)
                var state=data[1].split("=");
                state=state[1];
                this.code=code;
                this.state=state;
                // 截取电话号码
                let mobile = isReceiveCoupon.substring(isReceiveCoupon.length-11);
                // 调用后端接口
                request({
                    url: '/public/portal/empower/callback',
                    method: 'GET',
                    data:{
                        code:_this.code,
                        mobile:mobile
                    }
                }).then(res=>{

                });
                // 定时跳转回小程序界面
                setTimeout(function () {
                    wx.miniProgram.postMessage({ data: eval(_this.state.toLowerCase()) });
                    wx.miniProgram.switchTab({
                        url: '/pages/main/index/index'//小程序链接首页
                    });
                }, 500)
                return
            }
            // 请求微信授权
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd7352147e74ada09&redirect_uri="+redirect_uri+"&response_type=code&scope=snsapi_base&state="+isReceiveCoupon+"#wechat_redirect"
        },
    }
</script>

<style scoped>

</style>
